import React from 'react';

const IcNoteIcon = ({ size = 24 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20.108 20.001"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0 }}
  >
    <path d="M6.436 18.465H2.103C1.743 18.465 1.449 18.166 1.449 17.799V2.135C1.449 1.772 1.739 1.476 2.096 1.476H14.574C14.836 1.476 15.048 1.693 15.048 1.958V6.049C15.048 6.123 15.107 6.184 15.18 6.184H16.365C16.438 6.184 16.497 6.123 16.497 6.049V1.958C16.497 0.878 15.634 0 14.574 0H2.096C0.94 0 0 0.958 0 2.135V17.8C0 18.981 0.943 19.942 2.103 19.942H6.436C6.508 19.942 6.568 19.881 6.568 19.808V18.6C6.568 18.526 6.508 18.466 6.436 18.466V18.465Z" fill="#4B5563" />
    <path d="M13.107 5.089V3.605H3.539V5.156H13.107V5.089Z" fill="#4B5563" />
    <path d="M13.107 9.405V7.855H3.539V9.405H13.107Z" fill="#4B5563" />
    <path d="M3.539 12.003V13.553H8.556V12.003H3.539Z" fill="#4B5563" />
    <path d="M19.833 10.026C19.249 8.995 18.073 8.345 18.024 8.318C17.579 8.074 16.504 7.898 15.623 8.971L9.047 15.787L9.034 15.801L8.492 18.527C8.408 18.951 8.544 19.379 8.856 19.673C9.08 19.884 9.369 20.001 9.671 20.001C9.784 20.001 9.896 19.985 10.006 19.952L12.749 19.154L19.077 12.63L19.097 12.609C19.833 11.838 20.5 11.5 19.833 10.026ZM11.049 18.253L9.82 18.611L10.063 17.386L11.049 18.253ZM17.181 12.676L12.367 17.64L10.603 16.089L15.516 10.997L17.181 12.676ZM16.583 9.891L16.62 9.849C17.003 9.372 17.323 9.467 17.407 9.505C17.499 9.557 18.309 10.031 18.686 10.685C18.888 11.035 18.449 11.33 18.128 11.7L18.107 11.722L16.44 10.04L16.583 9.891Z" fill="#4B5563" />
  </svg>
);

export default IcNoteIcon;
